import { useState } from 'react'
import Styles from '../ShapesTab.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { ChevronDown2, CornerRadius } from 'blaze-ui/icons'
import { useUpdateStyle } from 'components/VisualStudioPlayground/VisualEditor/hooks/useUpdateStyle'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { Editor, SharedStyle, track } from '@tldraw/tldraw'
import { CornerRoundingStyle } from 'components/VisualStudioPlayground/VisualEditor/StyleProps'
import { ChevronRightSmall } from 'blaze-ui/icons/24'
import { SliderField } from 'components/Design/SliderField/SliderField'

interface Props {
  editor: Editor
  style: SharedStyle<number>
}

export const CornerRounding = track(({ editor, style }: Props) => {
  const updateStyle = useUpdateStyle(editor)
  const [isExpanded, setIsExpanded] = useState(false)

  if (style?.type === 'mixed') return null

  const isActive = (style?.value ?? 0) > 0

  return (
    <div className={Styles.colorSection}>
      <div className={Styles.actionRow} onClick={() => setIsExpanded(!isExpanded)}>
        <CornerRadius color="var(--selected-fill)" />
        <span className={Styles.actionName}>
          <Text variant="smallList">Corner rounding</Text>
        </span>
        <ToggleButton
          name="corner-rounding"
          size="sm-md"
          checked={isActive}
          handleChange={() => {
            if (isActive) {
              updateStyle(CornerRoundingStyle, 0)
              setIsExpanded(false)
            } else {
              updateStyle(CornerRoundingStyle, 10)
              setIsExpanded(true)
            }
          }}
        />
        {isExpanded ? <ChevronDown2 color="var(--dark-60)" /> : <ChevronRightSmall size={20} color="var(--dark-60)" />}
      </div>
      {isExpanded && (
        <div className={Styles.expandedSection}>
          {style && (
            <div className={Styles.field}>
              <SliderField
                label=""
                size="xs"
                value={style.type === 'shared' ? style.value : 0}
                onChange={(value) => updateStyle(CornerRoundingStyle, Math.round(value))}
              />
            </div>
          )}
        </div>
      )}
    </div>
  )
})
